<template>
    <section
        ref="section14"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="15"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
            >

            <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
                <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
                    <div><v-icon icon="home-repair-service" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 mr-6 text-heading-3-desktop">
                            Kaj je bilo prenovljeno v nepremičnini?
                        </div>
                        <div class="text-body-regular text-black-40">
                            Vnesite podrobne podatke o prenovi nepremičnine.
                            Te podatki so zelo pomembni za izboljšanje vaše
                            ponujene cene.
                        </div>
                    </div>

                    <v-lightbox is-authenticated footerless>
                        <template v-slot:trigger>
                            <div
                                class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                            >
                                <v-icon icon="question-mark" size="4"></v-icon>
                            </div>
                        </template>
                        <template v-slot:head>
                            <div class="flex items-start">
                                <v-icon
                                    icon="question-mark"
                                    class="mr-2.5"
                                    size="4.5"
                                ></v-icon>
                                <div>
                                    Dodatne informacije
                                </div>
                            </div>
                        </template>
                        <template v-slot:content>
                            <p class="mb-[10px] text-icon-text-medium">
                                Prenove na nepremičnini
                            </p>
                            <p class="mb-8 text-body-regular">
                                Tukaj vnesite podatke prenov vaše nepremičnine. Te podatki so pomembni za kupca ali najemnika, saj lahko samo tako približno ocenijo morebitne dodatne stroške. Pri letu zadnje prenove vnesite samo leto, kdaj je bilo na zadnje eno od opisanih del izvedeno. V kolikor nimate podatkov, pustite polja prazna.
                            </p>
                        </template>
                    </v-lightbox>
                </figure>
                <figure class="ml-auto mr-auto w-full max-w-lg">
                    <form method="POST" :action="routes.submitForm" id="select-property-renovations">
                        <v-csrf-token></v-csrf-token>
                        <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-8">
                            <li class="col-span-4">
                                <div
                                    :class="[
                                        'input group relative flex flex-col gap-[10px]',
                                        validationErrors.last_renovation_year
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                >
                                    <label
                                        for="letoZadnjePrenove"
                                        class="w-full text-body-medium-button"
                                    >
                                        <div class="label flex flex-col gap-[10px]">
                                            <div class="flex items-center gap-3">
                                                <v-icon
                                                    icon="handyman"
                                                    size="4"
                                                ></v-icon>
                                                <span>
                                                    Leto zadnje prenove
                                                    <sup>*</sup></span
                                                >
                                            </div>
                                        </div>
                                    </label>
                                    <input
                                        id="letoZadnjePrenove"
                                        type="number"
                                        name="last_renovation_year"
                                        placeholder="Leto"
                                        required
                                        v-model="lastRenovationYear"
                                    />
                                </div>
                            </li>
                            <li class="col-span-4">
                                <v-checkbox
                                    label="Prenova oken"
                                    checkbox-position="right"
                                    name="prenovaOken"
                                    :checked="Boolean(windowsRenovationCasted)"
                                    icon="window"
                                    @vchanged="
                                        windowsRenovation = !windowsRenovation
                                    "
                                    :class="[
                                        'checkbox group flex items-center',
                                        validationErrors.renovation_window
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                ></v-checkbox>
                            </li>
                            <li class="col-span-4">
                                <v-checkbox
                                    label="Prenova strehe"
                                    checkbox-position="right"
                                    name="prenovaStrehe"
                                    :checked="Boolean(roofRenovationCasted)"
                                    icon="roofing"
                                    @vchanged="roofRenovation = !roofRenovation"
                                    :class="[
                                        'checkbox group flex items-center',
                                        validationErrors.renovation_floor
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                ></v-checkbox>
                            </li>
                            <li class="col-span-4">
                                <v-checkbox
                                    label="Prenova tal"
                                    checkbox-position="right"
                                    name="prenovaTal"
                                    :checked="Boolean(floorsRenovationCasted)"
                                    icon="stairs"
                                    @vchanged="floorsRenovation = !floorsRenovation"
                                    :class="[
                                        'checkbox group flex items-center',
                                        validationErrors.renovation_roof
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                ></v-checkbox>
                            </li>
                        </ul>
                        <input
                            type="text"
                            name="renovation_window"
                            class="hidden"
                            v-model="windowsRenovationCasted"
                        />
                        <input
                            type="text"
                            name="renovation_floor"
                            class="hidden"
                            v-model="floorsRenovationCasted"
                        />
                        <input
                            type="text"
                            name="renovation_roof"
                            class="hidden"
                            v-model="roofRenovationCasted"
                        />
                    </form>
                </figure>
            </figure>
        </main>

        <v-add-listing-foot>
            <a
                @click="submitForm('select-property-renovations')"
                :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },
    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },
    data() {
        return {
            lastRenovationYear: null,
            windowsRenovation: null,
            floorsRenovation: null,
            roofRenovation: null,
        };
    },
    mounted() {
        this.lastRenovationYear = this.old.last_renovation_year
            ? this.old.last_renovation_year
            : this.stepData.last_renovation_year;
        this.windowsRenovation = this.old.renovation_window
            ? this.old.renovation_window
            : this.stepData.renovation_window;
        this.floorsRenovation = this.old.renovation_floor
            ? this.old.renovation_floor
            : this.stepData.renovation_floor;
        this.roofRenovation = this.old.renovation_roof
            ? this.old.renovation_roof
            : this.stepData.renovation_roof;
    },
    computed: {
        windowsRenovationCasted() {
            return this.windowsRenovation ? 1 : 0;
        },
        floorsRenovationCasted() {
            return this.floorsRenovation ? 1 : 0;
        },
        roofRenovationCasted() {
            return this.roofRenovation ? 1 : 0;
        },
        validated() {
            if(!this.lastRenovationYear) return false

            return true;
        }
    },
    methods: {
        submitForm(formId) {
            if(this.validated) document.getElementById(formId).submit();
        },
    },

};
</script>
